var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.138C11.7555 20.138 11.5192 20.0904 11.2913 19.9951C11.0634 19.8998 10.8645 19.7485 10.6946 19.5413L2.63699 9.86358C2.42177 9.59835 2.29451 9.29998 2.25521 8.96846C2.21588 8.63694 2.27285 8.31792 2.42614 8.01138L4.47939 3.86684C4.62865 3.58495 4.84006 3.35904 5.11361 3.18911C5.38718 3.01919 5.68555 2.93423 6.00874 2.93423H17.9913C18.3145 2.93423 18.6129 3.01919 18.8865 3.18911C19.16 3.35904 19.3734 3.58495 19.5267 3.86684L21.574 8.01138C21.7272 8.31792 21.7842 8.63694 21.7449 8.96846C21.7056 9.29998 21.5803 9.59835 21.3691 9.86358L13.3055 19.5413C13.1356 19.7485 12.9366 19.8998 12.7087 19.9951C12.4808 20.0904 12.2446 20.138 12 20.138ZM8.94406 8.24998H15.056L13.2109 4.56573H10.7892L8.94406 8.24998ZM11.25 17.6674V9.74998H4.66471L11.25 17.6674ZM12.75 17.6674L19.3354 9.74998H12.75V17.6674ZM16.737 8.24998H19.7973L17.9332 4.56573H14.8919L16.737 8.24998ZM4.20276 8.24998H7.26906L9.10819 4.56573H6.06689L4.20276 8.24998Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPremium);
export default __webpack_public_path__ + "static/media/icon-premium.f5953ac9d56696ba1f1f4a46e71a85fe.svg";
export { ForwardRef as ReactComponent };